<template>
  <!-- Modal Import -->
  <b-modal
      id="md-replace"
      title="Cập nhật vat hàng loạt"
      size="md"
      centered
      hide-footer
  >
    <div class="model-body d-flex justify-content-center mb-2">
      <component-currency-input v-model="vat" :max="100" :min="0" style="height: 30px; text-align: center"/>
    </div>
    <footer class="modal-footer px-0 pb-0">
      <button
          type="button"
          class="btn btn-light"
          @click="onClose"
      >
        <span>Đóng</span>
      </button>
      <button
          type="button"
          class="btn btn-primary"
          @click="onConfirm"
      >
        <span>Xác nhận</span>
      </button>
    </footer>
  </b-modal>
</template>
<script>
import ComponentCurrencyInput from "@/components/currency";
export default {
  name: 'ReplaceComponent',
  components: {
    ComponentCurrencyInput
  },
  data(){
    return {
      vat: 0
    }
  },
  methods: {
    onShow(){
      this.$bvModal.show("md-replace");
    },

    onClose(){
      this.$bvModal.hide("md-replace");
    },

    onConfirm(){
      this.$bvModal.hide("md-replace");
      this.$emit('confirm', this.vat)
    }
  }
}
</script>